import { FormikActions } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withStyles from '@material-ui/core/styles/withStyles';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// import { FLYBITS } from '../../../constants';
import ByodForm from '../../../containers/byod-form';
import { expandBYODView, expandConfigView } from '../actions/app';
import { updateKey } from '../actions/auth';
import { installSchema, saveMappings } from '../actions/config';
import MappingsForm from '../components/mappings-form';
import SsoForm from '../components/sso-form';
import { styles } from '../style';
import { IApp } from '../types/app';

class OpenWeatherMapContent extends React.Component<IApp | any, any> {
  public render() {
    console.log('OpenWeatherMapContent', this.props)

    const { classes } = this.props;
    return (
      <div style={this.props.style}>
        <Tooltip title='When enabled, this indicates the schema has been installed for this integration'>
          <FormControlLabel
            label='Schema Installed'
            control={
              <Switch checked={this.props.config.enabled} value='installed' onClick={this.toggleInstallSchema} />
            }
          />
        </Tooltip>
        <ExpansionPanel expanded={this.props.app.byodExpanded} onChange={this.togleExpandBYOD} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>BYOD (Bring Your Own Data)</Typography>
            <Typography className={classes.secondaryHeading}>Configure to load your own data at interval</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <ByodForm onSubmit={this.saveBYODConfig}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel expanded={this.props.app.configuredExpanded} onChange={this.togleExpandConfig} disabled={!this.props.config.enabled}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Configure Data Collector</Typography>
            <Typography className={classes.secondaryHeading}>Configure and authorize Flybits to collect data on your behalf</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <SsoForm onSubmit={this.saveKey}/>
          </ExpansionPanelDetails>
          <ExpansionPanelDetails>
            <MappingsForm style={{width: '100%'}} onSubmit={this.saveMappings}/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div >
    );
  }
  private toggleInstallSchema = () => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(installSchema(
      accessToken,
      tenantId,
      !this.props.config.enabled,
    ))
  }
  private saveBYODConfig = () => {
    window.alert('Not Implemented')
  }
  private togleExpandConfig = () => this.props.dispatch(expandConfigView(!this.props.app.configuredExpanded))
  private togleExpandBYOD = () => this.props.dispatch(expandBYODView(!this.props.app.byodExpanded))

  private saveKey = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(updateKey(
      accessToken,
      tenantId,
      values.apikey,
    ))
  }
  private saveMappings = (values: any, actions: FormikActions<any>) => {
    const accessToken = this.props.authentication.session.id
    const tenantId = this.props.tenant.id
    this.props.dispatch(saveMappings(
      accessToken,
      tenantId,
      JSON.parse(values.mappings),
    ))
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withStyles(styles)(withRouter(connect(
  mapStateToProps,
)(OpenWeatherMapContent)));



// WEBPACK FOOTER //
// ./src/sub-projects/openweathermap/containers/content.tsx